import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-third-party-consignment-field',
  templateUrl: './third-party-consignment-field.component.html',
  styleUrls: ['./third-party-consignment-field.component.scss']
})
export class ThirdPartyConsignmentFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
